import { useSyncExternalStore, type ReactNode } from 'react'
import type { TimelineElement, TimelineElementType } from '../../context/TimelineContext'
import type { ButtonGroupItem } from '../Common/ButtonGroup'

export type ManageActionsBarProps = {
  canEditBoard?: boolean
  openElement?: TimelineElement | null
  onCreateElement?: (type?: TimelineElementType) => void
  onCreateChecklist?: () => void
  onCreateRecurringChecklist?: () => void
  clipboardItems?: ButtonGroupItem[]
  saveItems?: ButtonGroupItem[]
  discardItems?: ButtonGroupItem[]
  headerControls?: ReactNode
}

let activeActionsBar: ManageActionsBarProps | null = null
const storeListeners = new Set<() => void>()

export const setManageActionsBar = (actions: ManageActionsBarProps | null) => {
  activeActionsBar = actions
  storeListeners.forEach((listener) => listener())
}

export const useManageActionsBarStore = (): ManageActionsBarProps | null => {
  return useSyncExternalStore(
    (callback) => {
      storeListeners.add(callback)
      return () => {
        storeListeners.delete(callback)
      }
    },
    () => activeActionsBar,
  )
}
